import { GenericDropdownOption } from 'App.types';
import { PaymentStatus } from '@round/api';

export const paymentStatusOptions: GenericDropdownOption<PaymentStatus>[] = [
    { value: 'UNPAID', label: 'Unpaid' },
    { value: 'PAID', label: 'Paid' },
    { value: 'IN_PROGRESS', label: 'In Progress' },
    { value: 'FAILED', label: 'Failed' },
];
